<app-header></app-header>

<app-error *ngIf="isError" [message]="errorMessage"></app-error>
<div style="height: 100px; background: #EEEEEE 0% 0% no-repeat padding-box;" class="border-3 border-bottom">
    <div class="row">
        <div class="col-md-12">
            <h2 class="pt-4 font-color-navy text-center"><b>Smtp Configuration</b></h2>
        </div>
    </div>
</div>
<div class="container mt-5">
    
    <div class="panel panel-body container-shadow">
        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="accordion-circle-heading bg-orange font-color-orange" data-bs-toggle="collapse"
                    data-bs-target="#details">
                    <div><i class="fa fa-file-text pt-1 pb-1 px-2"></i><span>Details</span></div>
                </div>
            </div>
            <br />
            <div class="vertical-line">
                <div class="panel-body mx-4" id="details">
                    <form [formGroup]="smtpForm">
                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="smtpHost">SMTP HOST</label>
                                <input type="text" class="form-control" id="smtpHost" formControlName="smtpHost"
                                [attr.disabled]="!isEdit ? true : null">
                            </div>
                            <div class="form-group col-md-5">
                                <label for="smtpPort">SMTP Port</label>
                                <input type="number" class="form-control" id="smtpPort" formControlName="smtpPort"
                                    [attr.disabled]="!isEdit ? true : null">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="timeOut">Timeout</label>
                                <input type="number" class="form-control" id="timeOut" formControlName="timeOut"
                                [attr.disabled]="!isEdit ? true : null">
                            </div>
                            <div class="form-group col-md-5">
                                <label for="secureSocketOptions">SECURE Socket options</label>
                                <input type="number" class="form-control" id="secureSocketOptions"
                                    formControlName="secureSocketOptions" [attr.disabled]="!isEdit ? true : null">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="fromAddress">FromAddress</label>
                                <input type="email" class="form-control" id="fromAddress" formControlName="fromAddress"
                                [attr.disabled]="!isEdit ? true : null">
                            </div>
                            <div class="form-group col-md-5">
                                <label for="accountName">Account Name</label>
                                <input type="text" class="form-control" id="accountName"
                                    formControlName="accountName" [attr.disabled]="!isEdit ? true : null">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="password">Password</label>
                                <input type="text" class="form-control" id="password" formControlName="password"
                                [attr.disabled]="!isEdit ? true : null">
                            </div>
                            <div class="form-group col-md-5">
                                <label for="domain">Domain</label>
                                <input type="text" class="form-control" id="domain"
                                    formControlName="domain" [attr.disabled]="!isEdit ? true : null">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="applicationBaseURL">ApplicationBaseURL</label>
                                <input type="url" class="form-control" id="applicationBaseURL" formControlName="applicationBaseURL"
                                [attr.disabled]="!isEdit ? true : null">
                            </div>
                            <div class="form-group col-md-5">
                                <label for="errorRecipient">ErrorRecipient</label>
                                <input type="email" class="form-control" id="errorRecipient"
                                    formControlName="errorRecipient" [attr.disabled]="!isEdit ? true : null">
                            </div>
                        </div>
                        
                        <div class="form-group col-md-5">
                        <div class="form-group form-check form-switch mt-3">
                            <label class="form-check-label" for="isActive">IsActive</label>
                            <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive" [attr.disabled]="!isEdit ? true : null">
                        </div>
                        </div>
                        <div class="form-row mt-3">
                            <div class="form-group col-md-4" style="display: flex;justify-content: flex-end;">
                                <div class="d-flexd-flex justify-content-end text-end" *ngIf="!isEdit">
                                    <button class="btn-new-ui-edit" type="submit" (click)="toggleEdit()">
                                      Edit
                                    </button>
                                </div>
                                <div class="d-flexd-flex justify-content-end text-end" *ngIf="isEdit">
                                    <button class="btn-new-ui" type="submit" (click)="toggleEdit()" style="margin-right: 10px;">
                                      Close
                                    </button>
                                    <button class="btn-new-ui" type="submit" (click)="onsubmit()">
                                        Submit
                                    </button>
                                </div>
                                <br>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>